import { QueryResultStatus, queryStatus } from '../model';
import { action, makeObservable, observable, runInAction } from 'mobx';
import once from 'lodash/once';

export interface PromiseStateParams<T> {
  createPromise: () => Promise<T>;
}

export class PromiseState<T> {
  private readonly createPromise: PromiseStateParams<T>['createPromise'];

  status: QueryResultStatus<T, unknown> = {
    ...queryStatus.idle,
    error: null,
    isFetching: false,
  };

  constructor(params: Readonly<PromiseStateParams<T>>) {
    this.createPromise = params.createPromise;

    makeObservable(this, {
      status: observable.ref,
      fetch: action,
    });
  }

  fetchOnce = once(() => this.fetch());

  async fetch() {
    try {
      this.status = {
        ...queryStatus.loading,
        error: null,
        isFetching: true,
      };
      const data = await this.createPromise();
      runInAction(() => {
        this.status = {
          ...queryStatus.success,
          error: null,
          isFetching: false,
          data,
        };
      });
    } catch (error) {
      runInAction(() => {
        this.status = {
          ...queryStatus.error,
          error,
          isFetching: false,
        };
      });
    }
  }
}
